import './ModalLink.sass';

import React, { FC } from 'react';
import { useRoute, Link } from 'react-router5';

import { ModalLinkProps } from '$shared/components/ModalLink/ModalLink.interface';
import { classNames } from '$utils';

export const ModalLink: FC<ModalLinkProps> = (props) => {
  const { route } = useRoute();

  const {
    name,
    children,
    className,
    routeOptions = {},
    routeParams = {},
    disabled = false,
  } = props;

  return (
    <Link
      className={classNames({
        ModalLink,
        className: true,
        [className ? className : '']: true,
        disabled,
      })}
      routeName={route.name}
      routeOptions={routeOptions}
      routeParams={{
        ...route.params,
        w: name,
        ...routeParams,
      }}
    >
      {children}
    </Link>
  );
};
